import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import ProductCard from './ProductCard';
import { mockProducts } from '../data/mockData';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const NewProducts = ({ onAddToCart, onQuickView }) => {
  const [ref, isVisible] = useIntersectionObserver({ once: true, threshold: 0.1 });

  const newProducts = mockProducts.filter(p => p.isNew).slice(0, 5);

  return (
    <section ref={ref} className="py-16 bg-background">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isVisible ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Novedades</h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Descubre las últimas incorporaciones a nuestro catálogo
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-12">
          {newProducts.map((product, index) => (
            <motion.div
              key={product.id}
              initial={{ opacity: 0, y: 30 }}
              animate={isVisible ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <ProductCard
                product={product}
                onAddToCart={onAddToCart}
                onQuickView={onQuickView}
              />
            </motion.div>
          ))}
        </div>

        <div className="text-center">
          <Button size="lg" variant="outline" className="ripple">
            Ver todas las novedades
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NewProducts;